const cookies = (() => {
  // https://stackoverflow.com/a/15724300
  function getCookie(name) {
    let value = `; ${document.cookie}`,
      parts = value.split(`; ${name}=`);

    if (parts.length == 2) {
      return parts
        .pop()
        .split(';')
        .shift();
    }
  }

  function setCookie(name, value, expires) {
    let cookie = `${name}= ${value}; path=/`;

    if (typeof expires !== 'undefined') {
      cookie = `${cookie}; expires=${expires}`;
    }

    document.cookie = cookie;
  }

  return { getCookie, setCookie };
})();

export default cookies;
